import { NavLink } from "react-router-dom";
import { isDemoMode } from "../utils/demoAuth";

function Sidebar() {
  const demoMode = isDemoMode();
  const route = (path) => (demoMode ? `/demo${path}` : path);

  return (
    <aside className="sidebar">
      <div className="brand">
        <div className="brand-icon">₹</div>
        <div>
          <h2>FinoraAI</h2>
          <p>AI Personal Finance</p>
        </div>
      </div>

      <nav className="nav-menu">
        <NavLink to={route("/dashboard")}>Dashboard</NavLink>
        <NavLink to={route("/expenses")}>Expenses</NavLink>
        <NavLink to={route("/income")}>Income</NavLink>
        <NavLink to={route("/budget")}>Budget</NavLink>
        <NavLink to={route("/reports")}>Reports</NavLink>
        <NavLink to={route("/settings")}>Settings</NavLink>
      </nav>

      <div className="sidebar-footer">
        <p>{demoMode ? "Demo Mode - Sample Data" : "Secure Workspace"}</p>
        <span>{demoMode ? "Real expenses hidden" : "Private data mode"}</span>
      </div>
    </aside>
  );
}

export default Sidebar;
